var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('unauth_h')))]),_c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('not_yet_open')))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }